import React from "react";
import { Testimonials } from "../../../store/salesLandingStore/testimonials/types";
import { Popover, OverlayTrigger } from "react-bootstrap";

function TestimonialTemplate(props: { userReview: Testimonials; arrayKey: number }) {
    const reviewStarsFn = (starCount: number) => {
        const row = [];
        for (var i = 0; i < starCount; i++) {
            row.push(<img role="option" key={i} className="review-stars" src={require("../../Assets/images/funnel/sales/idf-redstar.png").default} alt="Red star" />);
        }
        return row;
    };

    const PopoverWithContent = (content: string) => (
        <Popover id="popover-basic" className="sales-landing" style={{ marginLeft: "8px" }}>
            <Popover.Content className="popover-content">{content}</Popover.Content>
        </Popover>
    );

    const PopoverTrigger = (content: string) => {
        return (
            <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={PopoverWithContent(content)}>
                <span className="info-ico compare-plus" style={{ textDecoration: "underline", display: "inline" }}>
                    ..more
                </span>
            </OverlayTrigger>
        );
    };

    const getTitleFn = (title: string) => {
        if (title.length > 62) {
            return (
                <>
                    {title.substring(0, 60)} {PopoverTrigger(title)}{" "}
                </>
            );
        }
        return title;
    };

    const getDescriptionFn = (description: string) => {
        if (description.length > 168) {
            return (
                <>
                    "{description.substring(0, 168)}" {PopoverTrigger(description)}{" "}
                </>
            );
        }
        return <>"{description}"</>;
    };

    const getWhitespaceIndexes = (data: string) => {
        const indexes = [];

        for (let index = 0; index < data.length; index++) {
            if (data[index] === " ") {
                indexes.push(index);
            }
        }

        return indexes;
    };

    const getReviewerNameFn = (reviewerName: string) => {
        reviewerName = reviewerName.trim();
        reviewerName = reviewerName.charAt(0).toUpperCase() + reviewerName.slice(1);

        if (reviewerName.indexOf(" ") >= 0) {
            const indexesArray = getWhitespaceIndexes(reviewerName);
            if (indexesArray.length > 1) {
                reviewerName = reviewerName.slice(0, indexesArray[0]) + " " + reviewerName.charAt(indexesArray[indexesArray.length - 1] + 1).toUpperCase() + ".";
            } else {
                reviewerName = reviewerName.slice(0, indexesArray[0]) + " " + reviewerName.charAt(indexesArray[0] + 1).toUpperCase() + ".";
            }
        } else {
            reviewerName = reviewerName + " " + reviewerName.charAt(0).toUpperCase() + ".";
        }

        return reviewerName;
    };

    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const changeTimeZone = (date: any, timeZone: string) => {
        if (typeof date === "string") {
            return new Date(
                new Date(date).toLocaleString("en-US", {
                    timeZone,
                })
            );
        }

        return new Date(
            date.toLocaleString("en-US", {
                timeZone,
            })
        );
    };

    const getReviewPublishDateFn = (reviewPublishDate: string) => {
        let utcDate = reviewPublishDate;
        let localDate = changeTimeZone(utcDate, "America/New_York");

        let day = days[localDate.getDay()];
        let month = monthNames[localDate.getMonth()];
        let date = String(localDate.getDate()).padStart(2, "0");
        let year = localDate.getFullYear();

        let mydate = day + ", " + month + " " + date + ", " + year;

        return mydate;
    };

    return (
        <>
            <div className="reviews" key={props.arrayKey}>
                <p className="col-xs-12 clearfix reviews-para">
                    <span className="carousel-stars">{reviewStarsFn(props.userReview.reviewStars)}</span>
                    <span
                        className="ellipticalends"
                        style={{ overflow: "hidden", position: "relative", fontWeight: "normal", height: "105px", marginTop: "10px", marginBottom: "3px" }}
                    >
                        <span className="review-header">{getTitleFn(props.userReview.reviewHeader.toUpperCase())}</span>
                        <span className="review-text">{getDescriptionFn(props.userReview.reviewText)}</span>
                    </span>
                    <span className="reviewer-name">
                        {getReviewerNameFn(props.userReview.reviewerName)}
                        <span className="review-published-date">Published {getReviewPublishDateFn(props.userReview.reviewPublishDate)}</span>
                    </span>
                </p>
            </div>
        </>
    );
}

export default TestimonialTemplate;
